import React from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';

import AppModal from 'components/modal/appModal';
import { SimpleModalId } from 'constants/modalId';
import { createModalCloseAction, CloseModalAction } from 'actions/modalActions';
import { createDeleteParticipant } from 'api/participants/participants.actions';
import { callApi } from 'helpers/callApi/callApi';
import { Response } from 'helpers/callApi/callApi.types';

export type DeleteModalContentContainerProps = {
  id?: SimpleModalId;
  participantName?: string;
  closeModal: () => CloseModalAction;
  deleteParticipant: () => Response;
  reloadParticipants: () => void;
};

export const DeleteParticipantModalContent = ({
  id,
  participantName,
  deleteParticipant,
  closeModal,
  reloadParticipants,
}: DeleteModalContentContainerProps) => {
  const handleSubmit = () => {
    callApi({
      action: deleteParticipant,
      onSuccess: () => {
        closeModal();
        reloadParticipants();
      },
    });
  };

  return (
    <AppModal
      id={id}
      title="Delete Participant"
      hideOpenButton
      submitButtonLabel="Yes"
      submitAction={handleSubmit}
      closeButtonLabel="No"
      className="delete-modal"
    >
      <p>
        Are you sure you want to delete <strong>{participantName}</strong> from Participants list?
      </p>
    </AppModal>
  );
};

const mapDispatchToProps = (dispatch: Dispatch, { participantId, eventId }: any) => ({
  // @ts-ignore
  deleteParticipant: () => dispatch(createDeleteParticipant(participantId, eventId)),
  closeModal: () => dispatch(createModalCloseAction(SimpleModalId.DeleteParticipant)),
});

export const DeleteParticipantModalContentContainer = connect(
  null,
  mapDispatchToProps,
)(DeleteParticipantModalContent as any);
